import { LocalStorageConfigKeys } from '@config/app-storage/local-storage.config';

declare var initApp: any, layouts: any;

/**
 * Helper class để quản lý theme mode cho ứng dụng
 * Hỗ trợ đồng bộ theme giữa SmartAdmin và Taiga UI
 */
export class ThemeHelper {
  constructor() { }

  //#region SmartAdmin Theme Mode

  /**
   * Lấy theme hiện tại của hệ thống
   * @return các mode theme
   * @example 'light', 'dark', 'default'
   */
  public static getMode(): string {
    const setting = this.loadSettings();
    const { classHolder } = setting;
    if (classHolder.includes('mod-skin-dark')) {
      return ThemeMode.DARK;
    } else if (classHolder.includes('mod-skin-light')) {
      return ThemeMode.LIGHT;
    } else {
      return ThemeMode.DEFAULT;
    }
  }

  /**
   * Khởi tạo theme mode cho SmartAdmin
   * @param mode 'light' | 'dark' | 'default'
   */
  public static init(
    mode: 'light' | 'dark' | 'default' = 'default'
  ): void {
    layouts.mode(mode);
  }

  //#endregion SmartAdmin Theme Mode

  //#region SmartAdmin Theme Settings

  /**
   * @SmartAdmin
   * Lấy cấu hình theme từ Local Storage
   * @return object chứa các thiết lập theme
   * @example
   * {
   *   htmlRoot: '',
   *   classHolder: 'mod-bg-1 mod-nav-link nav-function-fixed mod-skin-dark',
   *   themeURL: '#'
   * }
   */
  public static loadSettings = function () {
    let t =
      localStorage.getItem(
        LocalStorageConfigKeys.global.layouts.themeSetting
      ) || '',
      e = t ? JSON.parse(t) : {};
    return Object.assign(
      {
        htmlRoot: '',
        classHolder: '',
        themeURL: '',
      },
      e
    );
  };

  //#endregion SmartAdmin Theme Settings
}

export const ThemeMode = {
  LIGHT: 'light',
  DARK: 'dark',
  DEFAULT: 'default',
};
